import "core-js/modules/es.array.push.js";
import notify from '@/utils/notify';
import { useAuthStore } from '@/store/auth';
import { useSimpleI18n } from '@/utils/i18n';
import { Operation, ArrowDown, Expand, Fold } from '@element-plus/icons-vue';
export default {
  name: 'NavbarComponent',
  components: {
    Operation,
    ArrowDown,
    Expand,
    Fold
  },
  setup() {
    const {
      t,
      currentLanguage,
      switchLanguage
    } = useSimpleI18n();
    return {
      t,
      currentLanguage,
      switchLanguage
    };
  },
  data() {
    return {
      navbarHeight: '70px',
      isAccountInfoLoading: false,
      mobileMenuOpen: false
    };
  },
  computed: {
    authStore() {
      return useAuthStore();
    },
    // Whether to show the "Brand tools" dropdown at all — i.e. the account
    // has at least one brand feature granted.
    hasAnyBrandFeature() {
      const f = this.authStore.featureAccess || [];
      return ['dashboard', 'colors', 'training', 'leads', 'store'].some(k => f.includes(k));
    },
    avatarStyle() {
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#42b983',
        color: 'white',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        fontSize: '20px'
      };
    }
  },
  watch: {
    '$route.path'() {
      this.mobileMenuOpen = false;
    },
    // Watch for login state changes
    'authStore.isLoggedIn'(newValue) {
      if (newValue) {
        // User just logged in, load account info
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      } else {
        // User logged out, account info is already cleared by store
        console.log('User logged out');
      }
    }
  },
  async mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // Refresh identity (incl. per-feature access) from the server so the nav
    // reflects current grants regardless of login method (e.g. WeChat login
    // doesn't carry featureAccess) or stale persisted state / admin changes.
    if (this.authStore.isLoggedIn) {
      try {
        const res = await this.$api.account.getAccountInfo();
        this.authStore.setAccountInfo(res.data);
      } catch (e) {
        // Keep whatever was persisted if the refresh fails.
      }
    }
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 50) {
        this.navbarHeight = '50px';
      } else {
        this.navbarHeight = '70px';
      }
    },
    handleLanguageChange(language) {
      if (this.switchLanguage(language)) {
        notify.success(this.t('messages.operationSuccess'));
      }
    },
    handleSelect(index, indexPath) {
      console.log(indexPath);
      this.$router.push(indexPath.route);
    },
    goToLogin() {
      this.$router.push('/login');
    },
    async handleCommand(command) {
      if (command === 'logout') {
        try {
          await this.$api.account.logout();
          this.authStore.logout();
          await this.$router.push('/');
        } catch (error) {
          // Even if logout API fails, clear local state
          this.authStore.logout();
          await this.$router.push('/');
          console.error('Logout error:', error);
        }
      } else if (command === 'account') {
        await this.$router.push('/account');
      } else if (command === 'profile') {
        await this.$router.push('/profile');
      } else if (command === 'settings') {
        await this.$router.push('/settings');
      }
    }
  }
};